<template>
    <v-dialog persistent v-model="ui.dialog" :width="$vuetify.breakpoint.smAndDown ? '100%' : '800px'">
        <v-card :loading="ui.sending" :disabled="ui.sending"
            :class="['pt-0', $vuetify.breakpoint.smAndDown ? 'pa-2' : 'pa-4']">
            <v-card-title>
                Importar
            </v-card-title>
            <v-card-subtitle>
                Para realizar la importación debe selecciona un archivo en
                formato CSV.
            </v-card-subtitle>
            <v-card-text>
                <v-form ref="form" v-model="ui.valid" lazy-validation @submit.prevent="store()">
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <v-file-input dense outlined v-model="file" :rules="[v.required]"
                                label="Seleccionar archivo"></v-file-input>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-space-between">
                <div>
                    <v-btn text small :loading="ui.downloading" @click="layoutDownload()">
                        Descargar template
                    </v-btn>
                </div>

                <div>
                    <v-btn text class="mr-1" color="primary" @click="close()" :disabled="ui.sending">
                        cancelar
                    </v-btn>

                    <v-btn color="primary" @click="send()" :disabled="!ui.valid" :loading="ui.sending">
                        enviar
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";
import { mapState } from "vuex";

// Class
import Csv from "@/../../GeneralComponents/Class/Csv";
import Article from "@/clas/Article";

export default {
    data() {
        return {
            layout: { name: null },

            data: {
                importResults: [],
            },

            v: V,

            file: null,

            default: {
                valid: true,
                dialog: false,
                sending: false,
                downloading: false,
            },

            ui: {
                importResultsDownloading: false,
            },
        };
    },

    created() {
        this.ui = Object.assign({}, this.default);

        EventBus.$on("ArticleImport", () => {
            this.ui.dialog = true;
        });
    },

    methods: {
        async send() {
            if (this.$refs.form.validate()) {
                try {
                    this.ui.sending = true;

                    let csv = new Csv();

                    let articles = await csv.csvToJson(this.file);

                    let response = await axios.post(
                        `${process.env.VUE_APP_API_SERVER}/auth/store/article`,
                        {
                            articles: articles,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${this.$store.state.acount.token}`,
                            },
                        }
                    );
                    this.ui.dialog = false
                } catch (error) {
                    EventBus.$emit("Error", { error: error, errorsShow: true });
                } finally {
                    this.ui.sending = false;

                    EventBus.$emit("ArticleIndex");
                }
            }
        },

        async layoutDownload() {
            try {
                this.ui.downloading = true;

                let csv = new Csv([
                    {
                        id: null,
                        code: null,
                        // active: null,
                        weight: null,
                        quality: null,
                        special: null,
                        // color_id: null,
                        contents: null,
                        base_price: null,
                        category_id: null,
                        description: null,
                        box_capacity: null,
                        base_discount: null,
                        // type_of_finish_id: null,
                        // available_ecommerce: null,
                        unit_of_measurement_id: null,
                    },
                ]);

                await csv.toCsv({
                    name: "layout_article_import",
                });

                csv.csvDownload();
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            } finally {
                this.ui.downloading = false;
            }
        },

        close() {
            this.$refs.form.reset();

            this.ui.dialog = false;
        },
    },

    computed: {
        ...mapState(["acount"]),
    },
};
</script>

<style lang="css" scoped></style>
